// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1rP9O","item":"Header_item__22WYI","network":"Header_network__1HddA","load":"Header_load__1tgsg"};